import { type Monaco } from '@monaco-editor/react';
import { HomeyAPI } from 'homey-api';

const configuredEditors = new WeakSet<Monaco>();

export async function configureHomeyScriptEditor(
  monaco: Monaco,
  api: HomeyAPI,
  { isTypeCheckingEnabled = false }: { isTypeCheckingEnabled?: boolean } = {},
) {
  const javascriptDefaults = monaco.languages.typescript.javascriptDefaults;

  javascriptDefaults.setCompilerOptions({
    lib: ['es2019'],
    target: monaco.languages.typescript.ScriptTarget.ES2019,
    allowNonTsExtensions: true,
    allowJs: true,
    checkJs: isTypeCheckingEnabled,
    moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs,
  });

  javascriptDefaults.setDiagnosticsOptions({
    noSemanticValidation: !isTypeCheckingEnabled,
    noSyntaxValidation: false,
    // HomeyScript runs the script body inside an async function.
    diagnosticCodesToIgnore: [1108, 1375, 1378],
  });

  let homeyType = 'HomeyAPIV3Cloud';

  if (HomeyAPI.isHomeyAPIV2(api)) {
    homeyType = 'HomeyAPIV2';
  } else if (HomeyAPI.isHomeyAPIV3Local(api)) {
    homeyType = 'HomeyAPIV3Local';
  }

  // Replace the shared global immediately when switching Homeys, even while libraries load.
  javascriptDefaults.addExtraLib(
    `declare var Homey: import('./node_modules/homey-api/assets/types/homey-api').${homeyType};`,
    'file:///homey.d.ts',
  );

  const { homeyScriptLibraries } = await import('./homeyScriptLibraries');

  if (configuredEditors.has(monaco)) {
    return;
  }

  for (const library of homeyScriptLibraries) {
    javascriptDefaults.addExtraLib(library.content, library.filePath);
  }

  configuredEditors.add(monaco);
}
